export const MFE_EVENTS = {
  EXIT_MARKETING_CHANNEL: "exit-marketing-channel",
} as const;

export type MfeEventName = (typeof MFE_EVENTS)[keyof typeof MFE_EVENTS];

export const MODAL_EXIT_DELAY_MS = 100;
